var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 22,
    viewBox: "0 0 57 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.56 0.651998L26.472 5.08H8.868L10.956 0.651998H28.56ZM4.692 13.9C5.028 13.18 5.496 12.508 6.096 11.884C6.72 11.26 7.404 10.72 8.148 10.264C8.916 9.784 9.732 9.412 10.596 9.148C11.46 8.884 12.312 8.752 13.152 8.752H24.708L22.62 13.18H13.8C13.152 13.18 12.504 13.372 11.856 13.756C11.232 14.14 10.788 14.608 10.524 15.16L9.372 17.608H20.532L18.444 22H6.6H0.84L4.692 13.9ZM54.833 0.651998H56.993L46.877 22H40.397L45.113 12.1L36.653 22H30.857L31.793 12.1L27.113 22H20.633L30.749 0.651998H32.909H38.669L37.373 14.368L49.073 0.651998H54.833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmBlackLogo);
export default __webpack_public_path__ + "static/media/em_black_logo.51dc7ef0ba5e4cab26ec0259d6ca32bb.svg";
export { ForwardRef as ReactComponent };